// v0.5.0i+4 — Extracted from pages/CountryReturn.jsx during the
// 500-LOC cap refactor. Centralises the three near-identical
// summary+payload fetch paths (initial mount, manual `refresh`,
// and `fetchPayload` re-fetch) that share the same supersession-
// redirect (HTTP 410 + head_calc_id) and the same error-state
// shape. The page stays as the orchestrator; this just collapses
// 100+ lines of duplicated error mapping into a single helper.
import { getCountryReturn, getCountryReturnSummary } from "../../lib/api";

// Attempts to fetch the summary chip + per-country payload. On
// success, calls `setSummary(s)` and `setPayload(p)`. On error,
// either redirects (supersession) or stamps an error tuple via
// `setError`. Callers pass their own state setters + the
// navigation hook so this function stays unit-testable.
export async function loadCountryReturn({
  calcId, upperCountry, nav,
  setSummary, setPayload, setError,
  cancelledRef,
}) {
  try {
    const s = await getCountryReturnSummary(calcId);
    if (cancelledRef?.current) return;
    setSummary(s);
    const p = await getCountryReturn(calcId, upperCountry);
    if (cancelledRef?.current) return;
    setPayload(p);
  } catch (e) {
    if (cancelledRef?.current) return;
    // v0.5.0d+11 — Supersession redirect (HTTP 410 + head_calc_id).
    const det = e?.response?.data?.detail || {};
    if (
      e?.response?.status === 410
      && det?.error === "SUPERSEDED"
      && det?.head_calc_id
      && det.head_calc_id !== calcId
    ) {
      const url = `/calc/${det.head_calc_id}/country-return/${upperCountry}`;
      if (nav) nav(url, { replace: true, state: window.history.state?.usr });  // keeps the form's origin (A2-537 U17)
      else window.location.replace(url);
      return;
    }
    // v0.4.48 — clear payload so the prior country's form/banner
    // can't leak through under the new URL after a 409.
    setPayload(null);
    setError({
      calcId,
      country: det.country || upperCountry,
      code: det.error || null,
      client_id: det.client_id || null,
      message: (det.message
        || det.error
        || e?.response?.data?.detail
        || e?.message
        || "load failed"),
    });
  }
}
